<template>
  <div class="date-picker__selection-key">
    <div class="flatpickr-day date-available" />
    <div class="date-picker__selection-key-text">
      <div>
        <template v-if="shouldShowArrivalDays">
          <translate v-if="!categories.length" :class="selectionTagClass">
            Showing arrive days for all accommodation types
          </translate>
          <translate v-else :class="selectionTagClass">
            Showing arrive days for selected accommodation types
          </translate>
        </template>
        <template v-else>
          <translate v-if="!categories.length" :class="selectionTagClass">
            Showing depart days for all accommodation types
          </translate>
          <translate v-else :class="selectionTagClass">
            Showing depart days for selected accommodation types
          </translate>
        </template>
        <span>
          <img
            v-for="category in categories"
            :key="category.id"
            :src="getCategorySvg(category.slug)"
            class="date-picker__selection-key-img"
          />
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { CampsiteCategory } from '~/utility/types/CampsiteCategory'

@Component
class DatesWizardKeys extends Vue {
  @Prop()
  categories: CampsiteCategory[]

  @Prop()
  shouldShowArrivalDays: boolean

  @Prop()
  selectionTagClass: string

  getCategorySvg(slug: string) {
    // https://www.lichter.io/articles/nuxt3-vue3-dynamic-images/#the-importmetaglob-trick
    const glob = import.meta.glob('@/assets/images/category-icons/*.svg', {
      query: '?url',
      eager: true,
    })
    return glob[`/assets/images/category-icons/${slug}.svg`].default
  }
}

export default toNative(DatesWizardKeys)
</script>
